import React from "react";
import { Upload, X } from "lucide-react";

interface ImageUploaderProps {
  imagePreview: string | null;
  onImageUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClearImage: () => void;
}

export const ImageUploader: React.FC<ImageUploaderProps> = ({ imagePreview, onImageUpload, onClearImage }) => {
  if (imagePreview) {
    return (
      <div className="relative">
        <img src={imagePreview} alt="Preview" className="object-cover w-full h-48 rounded-lg border border-gray-300" />
        <button
          type="button"
          onClick={onClearImage}
          className="absolute top-2 right-2 p-2 text-white bg-red-600 rounded-full transition-colors hover:bg-red-700"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    );
  }

  return (
    <div className="p-6 text-center rounded-lg border-2 border-gray-300 border-dashed transition-colors hover:border-green-500">
      <input type="file" accept="image/*" onChange={onImageUpload} className="hidden" id="image-upload" />
      <label htmlFor="image-upload" className="flex flex-col items-center cursor-pointer">
        <Upload className="mb-2 w-12 h-12 text-gray-400" />
        <p className="text-sm font-medium text-gray-600">Cliquez pour télécharger une image</p>
        <p className="mt-1 text-xs text-gray-500">PNG, JPG, GIF jusqu'à 5MB</p>
      </label>
    </div>
  );
};
